// import { walletStore } from '@infinitro/global/wallet';
// access like this do not export these from index
// thus this will only load for components that import it
import {} from '@apollo/client/core';
import { cfgBaseCurrency } from '@infinitro/config';
import { get, writable } from 'svelte/store';
import { AsyncWalletsForDisplay, Currency, CurrencyNetworkEnum, CurrencyNetworkToken, AsyncCryptoPrices as fetchCryptoPricesAsync, FiatCurrency, SystemStatus, WithdrawEligibility } from './api/api';
import { Api } from './api_client';
import { loggedIn } from './auth';
import { getKeyValue, storeKeyValue } from './kvstore';
export { Currency, CurrencyNetworkEnum, FiatCurrency };
export var RoundDirection;
(function (RoundDirection) {
    RoundDirection["up"] = "up";
    RoundDirection["down"] = "down";
    RoundDirection["nearest"] = "nearest";
})(RoundDirection || (RoundDirection = {}));
export const round = (value, digits = 2, roundDir = RoundDirection.down) => {
    switch (roundDir) {
        case RoundDirection.up:
            return Math.ceil(value * Math.pow(10, digits)) / Math.pow(10, digits);
        case RoundDirection.nearest:
            return Math.round(value * Math.pow(10, digits)) / Math.pow(10, digits);
        case RoundDirection.down:
        default:
            return Math.floor(value * Math.pow(10, digits)) / Math.pow(10, digits);
    }
};
const REFRESH_INTERVAL = 10000;
export const walletStore = writable(undefined);
export const walletsStore = writable([]);
export const tokenStore = writable([]);
const baseFiatCurrency = cfgBaseCurrency() && ['USDT'].includes(cfgBaseCurrency())
    ? FiatCurrency.USD
    : cfgBaseCurrency();
export const currencySelectedStore = writable(undefined);
function readDisplayInFiatPreference() {
    if (typeof window === 'undefined')
        return false;
    try {
        const ls = window.localStorage;
        if (!ls || typeof ls.getItem !== 'function')
            return false;
        return ls.getItem('displayInFiat') === 'true';
    }
    catch {
        return false;
    }
}
export const displayInFiat = writable(readDisplayInFiatPreference());
export const displayInFiatSymbol = writable('');
let _tokenStore = [];
let _networkStore = [];
tokenStore.subscribe((tokens) => {
    _tokenStore = tokens;
});
export const availableFiats = [
    // make configurable if/when required
    FiatCurrency.USD,
    FiatCurrency.EUR,
    //FiatCurrency.GBP,
    //FiatCurrency.CAD,
    FiatCurrency.JPY
];
export const fiatList = Object.values(FiatCurrency);
export const fiatListLower = fiatList.map((f) => f.toLowerCase());
export const currencyList = Object.values(Currency);
export const tokenList = Object.values(currencyList).filter((c) => !fiatListLower.includes(c));
export const networkList = Object.values(CurrencyNetworkEnum);
export const parseFiat = (value) => {
    if (value instanceof Token) {
        return [true, value.currency.toUpperCase()];
    }
    // if (typeof value === 'object') {
    // 	if (typeof value.currency === 'string') {
    // 		const pass = fiatList.includes(value.currency.toUpperCase() as FiatCurrency);
    // 		if (pass) return [true, value.currency.toUpperCase() as FiatCurrency];
    // 	}
    // }
    if (typeof value === 'string') {
        const pass = fiatList.includes(value.toUpperCase());
        if (pass)
            return [true, value.toUpperCase()];
    }
    return [false, undefined];
};
export const parseCurrency = (value) => {
    if (value instanceof Token) {
        return [true, value.currency];
    }
    // if (typeof value === 'object') {
    // 	if (typeof value.currency === 'string') {
    // 		const pass = currencyList.includes(value.currency.toLowerCase() as Currency);
    // 		if (pass) return [true, value.currency.toLowerCase() as Currency];
    // 	}
    // }
    if (typeof value === 'string') {
        const pass = currencyList.includes(value.toLowerCase());
        if (pass)
            return [true, value.toLowerCase()];
    }
    return [false, undefined];
};
export const parseNetwork = (value) => {
    if (value instanceof Network) {
        return [true, value.network];
    }
    // if (typeof value === 'object') {
    // 	if (typeof value.network === 'string') {
    // 		const pass = networkList.includes(value.network.toLowerCase() as CurrencyNetworkEnum);
    // 		if (pass) return [true, value.network.toLowerCase() as CurrencyNetworkEnum];
    // 	}
    // }
    if (typeof value === 'string') {
        const pass = networkList.includes(value.toLowerCase());
        if (pass)
            return [true, value.toLowerCase()];
    }
    return [false, undefined];
};
export const parseTokenCurrency = (value) => {
    if (value instanceof Token) {
        return [true, value.currency];
    }
    // if (typeof value === 'object') {
    // 	if (typeof value.currency === 'string') {
    // 		const pass = tokenList.includes(value.currency.toLowerCase() as Currency);
    // 		if (pass) return [true, value.currency.toLowerCase() as Currency];
    // 	}
    // }
    if (typeof value === 'string') {
        const pass = tokenList.includes(value.toLowerCase());
        if (pass)
            return [true, value.toLowerCase()];
    }
    return [false, undefined];
};
export const parseToken = (value) => {
    if (value instanceof Token) {
        return [true, value];
    }
    // if (
    // 	typeof value === 'object' &&
    // 	typeof value.currency === 'string' &&
    // 	typeof value.priceUsd === 'number' &&
    // 	typeof value.displayPrice === 'number'
    // ) {
    // 	return [true, value as Token];
    // }
    const [pass, currency] = parseTokenCurrency(value);
    if (!pass)
        return [false, undefined];
    if (pass) {
        const token = _tokenStore.find((t) => t.currency === currency);
        if (token) {
            return [true, token];
        }
        if (currency) {
            return [
                true,
                new Token({
                    currency: currency,
                    priceUsd: 0,
                    displayPrice: 0,
                    network: undefined,
                    networks: []
                })
            ];
        }
    }
    return [false, undefined];
};
export const parseFinancial = (value) => {
    // less than ideal as presently objects may pass more than one criteria
    if (value instanceof Token) {
        return [true, value];
    }
    if (value instanceof Network) {
        return [true, value];
    }
    const [isCurrency, currency] = parseCurrency(value);
    if (isCurrency)
        return [true, currency];
    const [isNetwork, network] = parseNetwork(value);
    if (isNetwork)
        return [true, network];
    const [isToken, token] = parseToken(value);
    if (isToken)
        return [true, token];
    return [false, undefined];
};
export const toFinancialString = (value) => {
    const [isCurrency, currency] = parseCurrency(value);
    if (isCurrency && currency && typeof currency === 'string')
        return currency.toLowerCase();
    const [isNetwork, network] = parseNetwork(value);
    if (isNetwork && network && typeof network === 'string')
        return network.toLowerCase();
    const [isToken, token] = parseToken(value);
    if (isToken && token)
        return token.currency.toLowerCase();
    return '';
};
let walletRefreshTimer = undefined;
let selectedWallet = undefined;
let selectedCurrency = undefined;
let _loggedIn = undefined;
loggedIn.subscribe(async (value) => {
    if (_loggedIn === value)
        return;
    _loggedIn = value;
    if (value === true) {
        currencySelectedStore.set((await getKeyValue(`selectedCurrency`)));
    }
    if (value === false) {
        walletStore.set(undefined);
        walletsStore.set([]);
    }
});
walletStore.subscribe((wallet) => {
    selectedWallet = wallet;
    if (wallet) {
        currencySelectedStore.set(wallet?.currency);
    }
});
currencySelectedStore.subscribe(async (currency) => {
    if (selectedCurrency === currency)
        return;
    selectedCurrency = currency;
    if (selectedCurrency) {
        const storedCurrency = await getKeyValue(`selectedCurrency`);
        if (!storedCurrency || storedCurrency != selectedCurrency)
            await storeKeyValue(`selectedCurrency`, selectedCurrency);
    }
});
export const initWallets = async (currency, accountNum) => {
    const storedCurrency = await getKeyValue(`selectedCurrency`);
    if (storedCurrency && storedCurrency != selectedCurrency)
        currencySelectedStore.set(selectedCurrency);
    await refreshWallets();
    if (currency) {
        await switchWallet(currency, accountNum);
    }
};
export const refreshWallets = async (currency, accountNum) => {
    if (walletRefreshTimer) {
        try {
            clearInterval(walletRefreshTimer);
        }
        catch {
            // ignore
        }
    }
    try {
        const result = await AsyncWalletsForDisplay({
            variables: { fiat: baseFiatCurrency },
            context: { api: Api.player },
            fetchPolicy: 'network-only'
        });
        if (result.data?.walletsForDisplay && result.data.walletsForDisplay.length > 0) {
            let wallets = result.data.walletsForDisplay.map((w) => new Wallet(w));
            const tokens = wallets
                .filter((w) => tokenList.includes(w.currency))
                .sort((a, b) => (b.priceUsd ?? 0) - (a.priceUsd ?? 0))
                .map((w) => {
                return new Token({
                    currency: w.currency,
                    priceUsd: w.priceUsd ?? 0,
                    displayPrice: w.displayPrice ?? 0,
                    networks: w.networks(),
                    network: w.networks() ? w.networks()[0] : undefined
                });
            });
            tokenStore.set(tokens);
            // filters to include wallets with balance but at least one wallet per currency, and must include the selected wallet
            wallets = wallets
                .filter((w) => w.accountNum == selectedWallet?.accountNum ||
                w.balance > 0 ||
                (w.displayBalance && w.displayBalance > 0) ||
                !wallets.find((v) => v.currency === w.currency && v.accountNum != w.accountNum))
                .sort((a, b) => b.balance !== a.balance ? b.balance - a.balance : (b.priceUsd ?? 0) - (a.priceUsd ?? 0));
            walletsStore.set(wallets);
            if (currency) {
                const w = await switchWallet(currency, accountNum);
                if (w) {
                    selectedWallet = w;
                    return;
                }
            }
            if (selectedWallet) {
                const selected = wallets.find((v) => v.accountNum === selectedWallet.accountNum);
                if (selected) {
                    if (selected.balance != selectedWallet.balance) {
                        walletStore.set(selected);
                        selectedWallet = selected;
                    }
                    return;
                }
            }
            const topWallet = wallets[0];
            if (selectedCurrency) {
                const selected = wallets.find((v) => v.currency === selectedCurrency);
                if (selected && (selected.balance > 0 || !selectedWallet)) {
                    walletStore.set(selected);
                    selectedWallet = selected;
                }
                else if (topWallet && (topWallet.balance > 0 || !selectedWallet)) {
                    walletStore.set(topWallet);
                    selectedWallet = topWallet;
                }
            }
            else if (topWallet && (topWallet.balance > 0 || !selectedWallet)) {
                walletStore.set(topWallet);
                selectedWallet = topWallet;
            }
        }
        if (!selectedWallet)
            walletStore.set(new Wallet({
                accountNum: 21075,
                balance: 0,
                balanceUsd: 0,
                currency: Currency.usdt,
                currencyDecimals: 2,
                displayBalance: 0,
                displayCurrency: Currency.usdt,
                displayDecimals: 2,
                displayPrice: 1,
                displaySymbol: '$',
                isBonus: false,
                priceUsd: 1,
                rolloverPlayed: 0,
                rolloverRequired: 0
            }));
    }
    catch (e) {
        console.log(`error refreshing wallet`);
    }
    finally {
        walletRefreshTimer = setTimeout(async () => {
            await refreshWallets();
        }, REFRESH_INTERVAL);
    }
};
export const switchWallet = (currency, accountNum) => {
    const wallet = get(walletsStore).find((w) => w.currency === currency &&
        ((!accountNum && w.isBonus === false) || w.accountNum === accountNum));
    if (wallet) {
        walletStore.set(wallet);
        selectedWallet = wallet;
        selectedCurrency = wallet.currency;
    }
    return wallet;
};
export const selectWallet = async (selected) => {
    if (selected && selected != selectedWallet)
        walletStore.set(selected);
};
export class Token {
    currency;
    priceUsd;
    displayPrice;
    network;
    networks;
    token;
    constructor(self) {
        this.currency = self.currency;
        this.priceUsd = self.priceUsd;
        this.displayPrice = self.displayPrice;
        this.network = self.network ?? undefined;
        this.networks = self.networks ?? [];
        this.token = self.token ?? undefined;
    }
    supportsNetwork(network) {
        if (network instanceof Network) {
            return this.networks.find((n) => n.network === network.network) != undefined;
        }
        return this.networks.find((n) => n.network === network) != undefined;
    }
}
export class Network {
    network;
    currencies;
    constructor(network, currencies) {
        this.network = network;
        this.currencies = currencies ?? [];
    }
    supportsCurrency(currency) {
        if (currency instanceof Token) {
            return this.currencies.includes(currency.currency);
        }
        return this.currencies.includes(currency);
    }
    getTokens() {
        return _tokenStore.filter((t) => this.currencies.includes(t.currency));
    }
}
export class Wallet {
    wallet;
    accountNum;
    balance;
    bonusBalance;
    balanceUsd;
    currency;
    currencyDecimals;
    currencyStatus;
    displayBalance;
    displayCurrency;
    displayDecimals;
    displayPrice;
    displaySymbol;
    isBonus;
    priceUsd;
    rolloverPlayed;
    rolloverRequired;
    walletStatus;
    cashoutEligibility;
    isDisabled;
    constructor(wallet) {
        this.wallet = wallet;
        this.accountNum = wallet.accountNum ?? 0;
        this.balance = wallet.balance;
        this.bonusBalance = wallet.bonusBalance;
        this.balanceUsd = wallet.balanceUsd;
        this.currency = wallet.currency;
        this.currencyDecimals = wallet.currencyDecimals ?? 0;
        this.currencyStatus = wallet.currencyStatus ?? undefined;
        this.displayBalance = wallet.displayBalance;
        this.displayCurrency = wallet.displayCurrency ?? undefined;
        this.displayDecimals = wallet.displayDecimals ?? 0;
        this.displayPrice = wallet.displayPrice;
        this.displaySymbol = wallet.displaySymbol ?? '';
        this.isBonus = wallet.isBonus ?? false;
        this.priceUsd = wallet.priceUsd;
        this.rolloverPlayed = Number(wallet.rolloverPlayed);
        this.rolloverRequired = Number(wallet.rolloverRequired);
        this.walletStatus = wallet.walletStatus ?? undefined;
        this.cashoutEligibility = wallet.cashoutEligibility ?? undefined;
        this.isDisabled = wallet.isDisabled ?? undefined;
    }
    get balanceString() {
        // returns the wallet balance as a string
        return `${round(this.wallet.balance, this.wallet.currencyDecimals ?? 0).toFixed(this.wallet.currencyDecimals ?? 0)}`;
    }
    get balanceStringNoBonus() {
        // returns the wallet balance as a string
        return `${round(this.wallet.balance - this.wallet.bonusBalance, this.wallet.currencyDecimals ?? 0).toFixed(this.wallet.currencyDecimals ?? 0)}`;
    }
    get displayBalanceString() {
        // returns the wallets fiat value as a string
        return `${this.wallet.displaySymbol}${round(this.wallet.displayBalance, this.wallet.displayDecimals ?? 0).toFixed(this.wallet.displayDecimals ?? 0)}`;
    }
    get displayBalanceStringNoBonus() {
        // returns the wallets fiat value as a string
        return `${this.wallet.displaySymbol}${round(this.wallet.displayBalance - this.wallet.bonusBalance, this.wallet.displayDecimals ?? 0).toFixed(this.wallet.displayDecimals ?? 0)}`;
    }
    amountToDisplay(cryptoValue) {
        // formats any amount using the wallet's crypto decimal settings
        return `${round(cryptoValue, this.wallet.currencyDecimals ?? 0).toFixed(this.wallet.currencyDecimals ?? 0)}`;
    }
    amountToDisplayCurrency(fiatValue, showSymbol = true) {
        // formats any amount using the display fiat decimal settings
        return `${showSymbol ? this.wallet.displaySymbol : ''}${round(fiatValue, this.wallet.displayDecimals ?? 0).toFixed(this.wallet.displayDecimals ?? 0)}`;
    }
    roundToDisplay(cryptoValue) {
        // formats any amount using the wallet's crypto decimal settings
        return round(cryptoValue, this.wallet.currencyDecimals ?? 0);
    }
    roundToDisplayWithCurrency(cryptoValue) {
        // formats any amount using the wallet's crypto decimal settings
        return `${round(cryptoValue, this.wallet.currencyDecimals ?? 0)} ${this.wallet.currency.toUpperCase()}`;
    }
    roundToDisplayCurrency(fiatValue) {
        // formats any amount using the display fiat decimal settings
        return round(fiatValue, this.wallet.displayDecimals ?? 0);
    }
    toDisplayCurrency(cryptoValue, roundDir = RoundDirection.down) {
        // converts any crypto amount to the display fiat numeric value
        return round(cryptoValue * (this.displayPrice ?? 0), this.displayDecimals ?? 0, roundDir);
    }
    toUsd(cryptoValue, roundDir = RoundDirection.down) {
        // converts any crypto amount to USD
        return round(cryptoValue * (this.priceUsd ?? 0), 2, roundDir);
    }
    toUsdString(cryptoValue, roundDir = RoundDirection.down) {
        // converts any crypto amount to a USD string with symbol
        return `$${round(cryptoValue * (this.priceUsd ?? 0), 2, roundDir).toFixed(2)}`;
    }
    fromUsd(usdValue, roundDir = RoundDirection.down) {
        if (!this.priceUsd || this.priceUsd === 0)
            return 0;
        // converts any USD amount to the crypto numeric value
        return round(usdValue / this.priceUsd, this.currencyDecimals ?? 0, roundDir);
    }
    toDisplayCurrencyString(cryptoValue, showSymbol = true) {
        // converts any crypto amount to the display fiat string value
        return `${showSymbol ? this.wallet.displaySymbol : ''}${this.toDisplayCurrency(cryptoValue).toFixed(this.displayDecimals ?? 0)}`;
    }
    fromDisplayCurrency(fiatValue) {
        // converts any fiat amount to the crypto numeric value
        return round(fiatValue / (this.displayPrice ?? 0), this.currencyDecimals ?? 0);
    }
    fromDisplayCurrencyString(fiatValue) {
        // converts any fiat amount to the crypto numeric value
        return `${this.fromDisplayCurrency(fiatValue).toFixed(this.currencyDecimals ?? 0)}`;
    }
    networksEnums() {
        // hardcode temporary until add to wallet return data
        switch (this.currency) {
            case Currency.usdt:
                return [
                    CurrencyNetworkEnum.ethereum,
                    CurrencyNetworkEnum.bsc,
                    CurrencyNetworkEnum.polygon,
                    CurrencyNetworkEnum.tron
                ];
            case Currency.usdc:
                return [CurrencyNetworkEnum.ethereum, CurrencyNetworkEnum.polygon];
            case Currency.eth:
                return [CurrencyNetworkEnum.ethereum];
            case Currency.bnb:
                return [CurrencyNetworkEnum.bsc];
            case Currency.btc:
                return [CurrencyNetworkEnum.bitcoin];
            case Currency.ltc:
                return [CurrencyNetworkEnum.litecoin];
            case Currency.matic:
            case Currency.pol:
                return [CurrencyNetworkEnum.polygon];
            case Currency.doge:
                return [CurrencyNetworkEnum.dogecoin];
            default:
                return [];
        }
    }
    networks() {
        return _networkStore.filter((n) => this.networksEnums().includes(n.network));
    }
}
// hardcode initial networks until returned in wallet metadata
const availableNetworks = [
    CurrencyNetworkEnum.bitcoin,
    CurrencyNetworkEnum.bsc,
    CurrencyNetworkEnum.dogecoin,
    CurrencyNetworkEnum.ethereum,
    CurrencyNetworkEnum.litecoin,
    CurrencyNetworkEnum.polygon,
    CurrencyNetworkEnum.tron
];
// hardcode initial networks <-> currency mapping until returned in wallet metadata
const getNetworkCurrencies = (network) => {
    switch (network) {
        case CurrencyNetworkEnum.bitcoin:
            return [Currency.btc];
        case CurrencyNetworkEnum.bsc:
            return [Currency.bnb, Currency.usdt];
        case CurrencyNetworkEnum.dogecoin:
            return [Currency.doge];
        case CurrencyNetworkEnum.ethereum:
            return [Currency.eth, Currency.usdt, Currency.usdc];
        case CurrencyNetworkEnum.litecoin:
            return [Currency.ltc];
        case CurrencyNetworkEnum.polygon:
            return [Currency.pol, Currency.usdt, Currency.usdc];
        case CurrencyNetworkEnum.tron:
            return [Currency.trx, Currency.usdt];
        default:
            return [];
    }
};
const getInitialNetworks = () => {
    return availableNetworks.map((n) => {
        const network = new Network(n, getNetworkCurrencies(n));
        return network;
    });
};
export const fiatSymbol = (fiat) => {
    switch (fiat) {
        case FiatCurrency.USD:
            return '$';
        case FiatCurrency.EUR:
            return '€';
        case FiatCurrency.GBP:
            return '£';
        case FiatCurrency.CAD:
            return '$';
        case FiatCurrency.JPY:
            return '¥';
        default:
            return '';
    }
};
loggedIn.subscribe(async (value) => {
    if (value) {
        if (walletRefreshTimer) {
            try {
                clearInterval(walletRefreshTimer);
            }
            catch {
                // ignore
            }
        }
        // TODO: change to a subscription instead of polling
        await refreshWallets();
    }
    else {
        if (walletRefreshTimer)
            clearInterval(walletRefreshTimer);
        walletRefreshTimer = undefined;
    }
});
export const networkStore = writable(getInitialNetworks());
networkStore.subscribe((value) => {
    _networkStore = value;
});
const cryptoPricesInterval = 1000 * 15;
let cryptoPricesTimer;
function initCryptoFeed() {
    setTimeout(() => fetchAndSetCryptoPrices(), 10);
    if (!cryptoPricesTimer) {
        cryptoPricesTimer = setInterval(() => fetchAndSetCryptoPrices(), cryptoPricesInterval);
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const cryptoPrices = writable(null, () => initCryptoFeed());
export async function fetchAndSetCryptoPrices(retries = 3, delay = 1000) {
    try {
        const response = await fetchAndSetCryptoPricesWithRetry(retries, delay);
        cryptoPrices.set(response.data.cryptoPrices);
    }
    catch (error) {
        console.log('Error fetching crypto prices', JSON.stringify(error, null, 2));
    }
}
async function fetchAndSetCryptoPricesWithRetry(retries, delay) {
    try {
        const response = await fetchCryptoPricesAsync({});
        return response;
    }
    catch (error) {
        if (retries === 0) {
            throw error;
        }
        console.log(`Retrying fetching crypto prices in ${delay}ms...`);
        await new Promise((resolve) => setTimeout(resolve, delay));
        return fetchAndSetCryptoPricesWithRetry(retries - 1, delay);
    }
}
export const isBaseCurrency = (currency) => currency?.toString().toLowerCase() === cfgBaseCurrency().toString().toLowerCase();
export const isCurrencyPegged = (fromCurrency, toCurrency) => {
    return isBaseCurrency(fromCurrency) && isBaseCurrency(toCurrency);
};
